type CloseFn = () => void;

/**
 * Стек открытых оверлеев.
 *
 * Нужен ровно для одного: нативная кнопка «назад» Telegram должна закрывать
 * открытый шит или модалку, а не уводить с экрана. Иначе пользователь,
 * закрывая фильтры, вылетает из каталога — и это выглядит как баг навигации.
 */
const stack: CloseFn[] = [];

export function pushOverlay(close: CloseFn): () => void {
  stack.push(close);
  return () => {
    const index = stack.lastIndexOf(close);
    if (index !== -1) stack.splice(index, 1);
  };
}

/** @returns был ли закрыт оверлей. `false` — можно переходить назад по истории. */
export function closeTopOverlay(): boolean {
  const close = stack.pop();
  if (!close) return false;
  close();
  return true;
}

export function hasOpenOverlay(): boolean {
  return stack.length > 0;
}
